module.exports = __webpack_public_path__ + "assets/img/download-back.74022ad8.png";